import axiosConfig from "./axiosConfig";

/**
 * Service for interacting with coupon-related API endpoints
 */
const couponService = {
  /**
   * Get all coupons with pagination and filters
   * @param {Object} params - Query parameters
   * @param {number} params.page - Page number
   * @param {number} params.limit - Items per page
   * @param {boolean} params.isActive - Filter by active status
   * @param {string} params.search - Search term for code
   * @returns {Promise<Object>} - Paginated coupons data
   */
  getAllCoupons: async (params = {}) => {
    const response = await axiosConfig.get("/coupons", { params });
    return response.data;
  },

  /**
   * Get a coupon by ID
   * @param {string} id - Coupon ID
   * @returns {Promise<Object>} - Coupon data
   */
  getCouponById: async (id) => {
    const response = await axiosConfig.get(`/coupons/${id}`);
    return response.data;
  },

  /**
   * Create a new coupon
   * @param {Object} couponData - Coupon data
   * @returns {Promise<Object>} - Created coupon data
   */
  createCoupon: async (couponData) => {
    const response = await axiosConfig.post("/coupons", couponData);
    return response.data;
  },

  /**
   * Update an existing coupon
   * @param {string} id - Coupon ID
   * @param {Object} couponData - Updated coupon data
   * @returns {Promise<Object>} - Updated coupon data
   */
  updateCoupon: async (id, couponData) => {
    const response = await axiosConfig.put(`/coupons/${id}`, couponData);
    return response.data;
  },

  /**
   * Delete a coupon
   * @param {string} id - Coupon ID
   * @returns {Promise<Object>} - Delete confirmation
   */
  deleteCoupon: async (id) => {
    const response = await axiosConfig.delete(`/coupons/${id}`);
    return response.data;
  },

  /**
   * Validate a coupon code for the current cart
   * @param {Object} data - Validation data
   * @param {string} data.code - Coupon code
   * @param {number} data.cartTotal - Cart subtotal
   * @param {Array} data.cartItems - Cart items array
   * @returns {Promise<Object>} - Validation result including discount amount if valid
   */
  validateCoupon: async (data) => {
    const response = await axiosConfig.post("/coupons/validate", data);
    return response.data;
  },
};

export default couponService;
